import { z } from 'zod';

import {
  zodInvoiceDetailSchema,
  zodUserFileSchema,
} from '../useQueryInvoiceDetail/validations';

export const zodInvoiceUserFileRoleSchema = z.enum([
  'misc',
  'performance_record',
]);

const zodAttachInvoiceUserFilePayloadSchema = z.object({
  contentType: z.string().trim().min(1),
  fileId: z.string().trim().min(1),
  filename: z.string().trim().min(1),
  role: zodInvoiceUserFileRoleSchema,
});

export const zodAttachInvoiceUserFilesPayloadSchema = z
  .array(zodAttachInvoiceUserFilePayloadSchema)
  .min(1)
  .max(20);

export const zodAttachInvoiceUserFilesResponseSchema = z.object({
  attached: z.array(zodUserFileSchema),
  failed: z.array(zodAttachInvoiceUserFilePayloadSchema),
  invoice: zodInvoiceDetailSchema,
});
